import React from "react"
import { useGetTokens } from "../hooks/useGetTokens"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa"

import socialStyles from "../styles/global.module.scss"

const SocialMediaLinks = () => {
  const sociallink = useGetTokens()

  return (
    <div className={socialStyles.socialBtns}>
      {!sociallink.SocialMediaLinks.facebook ||
      sociallink.SocialMediaLinks.facebook === "" ? (
        <span></span>
      ) : (
        <OutboundLink
          title="Facebook"
          target="_blank"
          rel="noopener"
          href={`${sociallink.SocialMediaLinks.facebook}`}
        >
          <FaFacebookF />
        </OutboundLink>
      )}
      {!sociallink.SocialMediaLinks.instagram ||
      sociallink.SocialMediaLinks.instagram === "" ? (
        ""
      ) : (
        <OutboundLink
          title="Instagram"
          target="_blank"
          rel="noopener"
          href={`${sociallink.SocialMediaLinks.instagram}`}
        >
          <FaInstagram />
        </OutboundLink>
      )}
      {!sociallink.SocialMediaLinks.twitter ||
      sociallink.SocialMediaLinks.twitter === "" ? (
        ""
      ) : (
        <OutboundLink
          title="Twitter"
          target="_blank"
          rel="noopener"
          href={`${sociallink.SocialMediaLinks.twitter}`}
        >
          <FaTwitter />
        </OutboundLink>
      )}
      {!sociallink.SocialMediaLinks.linkedin ||
      sociallink.SocialMediaLinks.linkedin === "" ? (
        ""
      ) : (
        <OutboundLink
          title="LinkedIn"
          target="_blank"
          rel="noopener"
          href={`${sociallink.SocialMediaLinks.linkedin}`}
        >
          <FaLinkedinIn />
        </OutboundLink>
      )}
      {!sociallink.SocialMediaLinks.youtube ||
      sociallink.SocialMediaLinks.youtube === "" ? (
        ""
      ) : (
        <OutboundLink
          title="YouTube"
          target="_blank"
          rel="noopener"
          href={`${sociallink.SocialMediaLinks.youtube}`}
        >
          <FaYoutube />
        </OutboundLink>
      )}
    </div>
  )
}
export default SocialMediaLinks
